import { checkoutContext } from '@contexts/checkout'
import { useContext } from 'react'

export function useCheckoutContext() {
  const ctx = useContext(checkoutContext)
  return ctx
}
